import { I18NextContext } from "../services/i18nService";

// usage:
// <div i18n-type="DEALER" i18n-key="Code">Backup Text</div>
// => if types.DEALER.Code exists
// <div>{{i18n.t(types.DEALER.Code)}}</div>
// => if types.DEALER.Code !exists
// <div>Backup Text</div>
// also i18n-type can be omitted to get a top level (non-entity) translation

function i18nTranslate($compile) {
	return {
		restrict: "A", 
		scope: {
			i18nKey: "@", 
			i18nType: "@",
			i18nCount: "@"
		},
		link: function(scope, element) {
			const defaultText = element.text() || "";

			function updateTranslations() {
				if(scope.i18nType) {
					const translatedText = I18NextContext.Instance.translateEntityType(scope.i18nType, scope.i18nKey, defaultText, scope.i18nCount);
					element.html(translatedText);
				}
				else {
					const translatedText = I18NextContext.Instance.translateKey(scope.i18nKey, defaultText, scope.i18nCount);

					element.html(translatedText);
				}
				$compile(element.contents())(scope.$parent); 
			}

			updateTranslations();

			scope.$watch("i18nKey", function() {
				updateTranslations();
			});

			scope.$watch("i18nType", function() {
				updateTranslations();
			});
		}
	};
}

export default angular
	.module("vesl.behaviors.i18nTranslate", [])
	.directive("i18nTranslate", i18nTranslate).name;
